module.exports = __webpack_public_path__ + "static/media/stephen-carr-architects.c35b078d.png";